import { useEffect } from "react"

import { useDeepEqualMemo } from "@/hooks/useDeepEqualMemo.ts"

let focusIdSequence = 0
let focusIdProcessed = false

export function nextFocusId(): string {
  focusIdSequence++
  focusIdProcessed = false
  return `${focusIdSequence}`
}

function markFocusIdProcessed(focusId: string) {
  const focusIdNumber = parseInt(focusId, 10)
  if (Number.isNaN(focusIdNumber)) {
    return
  }
  if (focusIdNumber === focusIdSequence) {
    focusIdProcessed = false
  }
}

function isFocusIdRelevant(focusId: string): boolean {
  const focusIdNumber = parseInt(focusId, 10)
  if (Number.isNaN(focusIdNumber)) {
    return false
  }
  return focusIdNumber === focusIdSequence && !focusIdProcessed
}

export function useScrollIntoViewEffect(focusId?: string | null, options?: boolean | ScrollIntoViewOptions, maxRetries: number = 10) {
  const _options = useDeepEqualMemo(options)

  useEffect(() => {
    let handle: number | null = null
    let retries: number = 0

    function doScroll() {
      if (focusId && isFocusIdRelevant(focusId)) {
        const element = document.querySelector(`[data-focus-id="${focusId}"]`)
        if (element) {
          element.scrollIntoView(_options)
          markFocusIdProcessed(focusId)
        } else {
          if (retries < maxRetries) {
            retries++
            handle = requestAnimationFrame(doScroll)
          }
        }
      }
    }

    doScroll()

    return () => {
      if (handle) {
        cancelAnimationFrame(handle)
      }
    }
  }, [focusId, maxRetries, _options])
}

